module.exports = __webpack_public_path__ + "images/d1ca5b3651dc50722ab4e3f1809d2e41-GWMP9285a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/home/GWMP9285a.jpg
// module id = ./src/assets/images/slides/home/GWMP9285a.jpg
// module chunks = 0